import matchSorter from 'match-sorter';
import { FilterValue, IdType, Row } from 'react-table';

export function fuzzyTextKeyFilter<T extends object>(rows: Array<Row<T>>, id: IdType<T>, filterValue: FilterValue) {
  return matchSorter(rows, filterValue, {
    keys: [(row: Row<T>) => row.values[id].key]
  });
};

// Let the table remove the filter if the string is empty
fuzzyTextKeyFilter.autoRemove = (val: any) => !val;
